/**
 * 列表查询参数拼装（nos 自己一份，语义比 scr 的简化版更简单）。
 *
 * nos 后端三个列表筛选结构体的每个字段都带 form tag
 * （internal/httpapi/master.go 的 siteQuery / simQuery、lane.go 的 laneQuery，
 * 以及 pkg/httpx/page.go 里 PageQuery 的 `form:"page"` / `form:"size"`），
 * gin 的查询绑定能直接命中小写下划线的 key，所以**不需要**再补一套 Go 字段名。
 * 仓库里 pkg/httpx/query_tag_test.go 会守住 form tag 不被漏写，前端不必替后端兜底。
 *
 * 这里只做清洗：undefined / null / 空串不上送，字符串顺手 trim。
 * 只打了空格的关键词等价于没填，而 `LIKE '%%'` 会把整张表扫一遍。
 */
export function listQuery(q: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {}
  for (const [key, raw] of Object.entries(q)) {
    if (raw === undefined || raw === null) continue
    const value = typeof raw === 'string' ? raw.trim() : raw
    if (value === '') continue
    out[key] = value
  }
  return out
}
